/**
 * The primary action on a gate screen — the dark, full-width button that ends
 * an enquiry, a download, a save, a subscribe or a booking.
 *
 * One string rather than six copies. This recipe was pasted into each gate's
 * own module and drifted only in how it spelled its label size (`text-xl`
 * against `text-[1.25rem]`, the same value), which is what a copy does before
 * it drifts somewhere that shows.
 *
 * The corner comes from `--radius-btn-l`, not a literal, so these six ride the
 * same flag as every other button. Hardcoded, they drew the revamp corner with
 * the flag off and put a rounded rectangle next to the pill on
 * `BookMeetingGateSteps` — one journey, two shapes.
 */
export const GATE_CTA_CLASS =
    'flex h-14 w-full items-center justify-center rounded-[var(--radius-btn-l)] bg-[#181818] text-[1.25rem] font-medium tracking-[-0.02em] text-[#f3f3f3] shadow-[0_0.1875rem_0.8125rem_0_rgba(0,0,0,0.25),0_1.25rem_2.125rem_0_rgba(0,0,0,0.25)] transition-colors hover:bg-[#2c2c2c]';
